import clsx from 'clsx'
import CloseIcon from '@/assets/close.svg?react'
import StoryArrowIcon from '@/assets/story-arrow.svg?react'
import StoryNavigationButton from './StoryNavigationButton'
import styles from './StoryViewerControls.module.css'

export interface StoryViewerControlsProps {
	navigation?: {
		canPreviousPerson: boolean
		canNextPerson: boolean
		onPreviousPerson: () => void
		onNextPerson: () => void
	}
	interactionDisabled?: boolean
	onClose: () => void
}

export default function StoryViewerControls({
	navigation,
	interactionDisabled = false,
	onClose,
}: StoryViewerControlsProps) {
	const showPersonNavigation = navigation?.canPreviousPerson || navigation?.canNextPerson
	const previousDisabled = interactionDisabled || !navigation?.canPreviousPerson
	const nextDisabled = interactionDisabled || !navigation?.canNextPerson

	return (
		<>
			<button type="button" className={styles.closeButton} aria-label="关闭日记" onClick={onClose}>
				<CloseIcon />
			</button>
			{showPersonNavigation && navigation && (
				<>
					<div className={clsx(styles.personButtonPosition, styles.previousPersonButton)}>
						<StoryNavigationButton
							className={styles.personButton}
							label="查看上一位用户的日记"
							disabled={previousDisabled}
							onClick={navigation.onPreviousPerson}
						>
							<StoryArrowIcon className={styles.arrowLeft} aria-hidden="true" />
						</StoryNavigationButton>
					</div>
					<div className={clsx(styles.personButtonPosition, styles.nextPersonButton)}>
						<StoryNavigationButton
							className={styles.personButton}
							label="查看下一位用户的日记"
							disabled={nextDisabled}
							onClick={navigation.onNextPerson}
						>
							<StoryArrowIcon className={styles.arrowRight} aria-hidden="true" />
						</StoryNavigationButton>
					</div>
				</>
			)}
		</>
	)
}
